module.exports = __webpack_public_path__ + "img/any-bg3.94d63c39.png";